import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dialog-resultado',
  templateUrl: './dialog-resultado.component.html',
  styleUrls: ['./dialog-resultado.component.scss']
})
export class DialogResultadoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
